import { FC } from 'react'

interface MarketplaceCardProps {
    image: string
    title: React.ReactNode
    subtitle: React.ReactNode
    description: React.ReactNode
    buttonText: string
    onClick: () => void
}

export const MarketplaceCard: FC<MarketplaceCardProps> = ({ image, title, buttonText, subtitle, description, onClick }) => {
    return (
        <div className="block h-full">
            <div className="p-6 h-full border border-[#EAECF0] rounded-[16px] flex flex-col bg-white">
                <div className="mb-[32px] rounded-[12px] overflow-hidden bg-white w-full h-full max-h-[200px] shadow-sm">
                    <img src={image} className="h-full w-full object-cover" alt="" />
                </div>
                <div className="mb-3 text-color-primary text-sm font-semibold">
                    {subtitle}
                </div>
                <div className="mb-3 text-nowrap overflow-hidden overflow-ellipsis text-color-dark text-2xl font-semibold">
                    {title}
                </div>
                <div className="text-base flex-1 font-normal mb-[32px] text-[#535862]">
                    {description}
                </div>
                <button onClick={onClick} className="form_handle_button">
                    {buttonText}
                </button>
            </div>
        </div>
    )
}